<template>
    <div class="rodemap">
        <WordDialog :key="index" :data="arr[index]" @jump="jump"></WordDialog>
        <div class="shop-guide" v-if="guideShow" @click="toShop"></div>
    </div>
</template>

<script>
    //script
    import Tools from '../../../scripts/tools';
    import {gsap} from 'gsap';
    //Global
    import Global from '../../../scripts/Global';
    import WordDialog from '../../cmp/wordDialog';

    export default {
        data() {
            return {
                index: 0,
                guideShow: false,
                arr: [
                    {
                        headImg: '乔诗语讲解',
                        word:
                            '啊，终于到啦！这里呢就是非常热门的故宫商店了，也就是位育斋！从前呢是作为佛堂使用的。',
                        audio: 'qsy',
                        scene: 'scene12',
                    },
                    {
                        headImg: '乔诗语讲解',
                        word:
                            '一开始叫做对育轩，嘉靖年间呢曾更名为玉芳轩，清朝才改叫为位育斋的。走，我们去买点纪念品作为今天的美好结束！',
                        audio: 'qsy',
                        scene: 'scene13',
                    },
                ],

            };
        },
        components: {
            WordDialog,
        },
        created() {
        },
        computed: {},
        methods: {
            jump(event) {
                this.index += 1;
                if (this.arr.length === this.index) {
                    this.index--;
                    this.guideShow = true;
                }
            },
            toShop() {
                this.$router.replace('/rodemap/qsy/09');
            }
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .rodemap {
        background-image: url(//cdn.original-fun.com/gugong/位育斋.jpg);
        background-position: center;
        width: 100vw;
        height: 100vh;
        max-width: 75vh;
        margin: 0 auto;
        overflow: hidden;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .shop-guide {width: 0.96rem;height: 0.96rem;background-image: url(./../../../assets/common/qsy-guide.png);@include singleBg;position: absolute;top: 50%;left: 50%;margin-left: -0.48rem;margin-top: -0.48rem;animation: guide-light 1.5s infinite linear both;}
    @keyframes guide-light {
        0% {transform: scale(1)}
        50% {transform: scale(1.2)}
        100% {transform: scale(1)}
    }
</style>
